"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelFactsItem = _interopRequireDefault(require("../HotelFactsItem"));
var _excluded = ["facts"];
var HotelFacts = function HotelFacts(_ref) {
  var facts = _ref.facts,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelFacts, props, facts.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(StyledFactsItem, (0, _extends2["default"])({}, item, {
      key: item.title
    }));
  }));
};
var StyledHotelFacts = _styledComponents["default"].div.withConfig({
  displayName: "HotelFacts__StyledHotelFacts",
  componentId: "sc-1xl322-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;"]);
var StyledFactsItem = (0, _styledComponents["default"])(_HotelFactsItem["default"]).withConfig({
  displayName: "HotelFacts__StyledFactsItem",
  componentId: "sc-1xl322-1"
})(["flex:50%;max-width:50%;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelFacts);